import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import { fetchCurrentUser } from '../services/api/users';
import { setProvider } from '../services/svpProvider';

export const useCurrentUserFetch = () => {
  const { data: user } = useQuery({
    queryKey: ['user', 'current'],
    queryFn: fetchCurrentUser,
  });

  useEffect(() => {
    if (user) {
      setProvider(user.provider);
    }
  }, [user]);

  return { user };
};
